// @flow

import type {Traveler} from 'redux/v1/travelers/data/models';

import {formatISOtoDateString} from 'utils';

export const prepareTravelers = (travelers: Traveler[]): Traveler[] => {
  return travelers.map((traveler: Traveler) => ({
    ...traveler,
    birthday: formatISOtoDateString(traveler.birthday),
  }));
};
